import { render } from "./AddAdressePostaleModal.vue?vue&type=template&id=0bb5d160&ts=true"
import script from "./AddAdressePostaleModal.vue?vue&type=script&lang=ts"
export * from "./AddAdressePostaleModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__